import { useGetMyAccount } from '@queries/Account'
import type { Account } from '@models/Account'

export const useGetAccount = (): Account | undefined => {
  const { data: user } = useGetMyAccount()
  return user
}

export default useGetAccount
